// eslint-disable-next-line camelcase

import { AppLoading } from 'expo';
import { useFonts } from 'expo-font';
import AppProvider from 'hooks';
import path from 'path';
import React, { useEffect } from 'react';
import { View } from 'react-native';
import { ThemeProvider } from 'styled-components/native';
import url from 'url';

import {
  Roboto_400Regular as Roboto400Regular,
  Roboto_500Medium as Roboto500Medium,
  Roboto_700Bold as Roboto700Bold
} from '@expo-google-fonts/roboto';
import { LinkingOptions, NavigationContainer } from '@react-navigation/native';
import Analytics from '@utils/analytics';

import AppRoutes from './src/routes';
import {
  navigationRef,
  isReadyRef,
  routeNameRef
} from './src/routes/rootNavigation';
import theme from './src/theme/theme';

const pathName = url.parse(process.env.WEB_PUBLIC_URL || '').pathname ?? null;
const suffix = pathName ? `${pathName.replace(/\//g, '')}/` : null;

function generateRelativeUrl(suffixUrl: string): string {
  return suffix ? path.join(suffix, suffixUrl) : suffixUrl;
}

const linking: LinkingOptions = {
  prefixes: [],
  config: {
    screens: {
      Callback: generateRelativeUrl('auth/callback'),
      Main: generateRelativeUrl('main'),
      InvoiceDetail: generateRelativeUrl('invoiceDetail'),
      PostingInvoices: generateRelativeUrl('postingInvoices'),
      Robot: generateRelativeUrl('robot')
    }
  }
};

const App: React.FC = () => {
  const [fontsLoaded] = useFonts({
    Roboto_400: Roboto400Regular,
    Roboto_500: Roboto500Medium,
    Roboto_700: Roboto700Bold
  });

  useEffect(() => {
    isReadyRef.current = false;
  }, []);

  const handleOnStateChange = async () => {
    const previousRouteName = routeNameRef.current;
    const currentRouteName = navigationRef.current?.getCurrentRoute()?.name;

    if (previousRouteName !== currentRouteName) {
      Analytics.sendPageView(currentRouteName);
    }

    routeNameRef.current = currentRouteName;
  };

  if (!fontsLoaded) {
    return <AppLoading />;
  }

  return (
    <ThemeProvider theme={theme}>
      <NavigationContainer
        linking={linking}
        ref={navigationRef}
        onReady={() => {
          routeNameRef.current = navigationRef.current?.getCurrentRoute()?.name;
          isReadyRef.current = true;
        }}
        onStateChange={handleOnStateChange}
      >
        <AppProvider>
          <View style={{ flex: 1, backgroundColor: '#F2F2F2' }}>
            <AppRoutes />
          </View>
        </AppProvider>
      </NavigationContainer>
    </ThemeProvider>
  );
};

export default App;
